(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1965],{

/***/ 21965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ RealTimeAudiences; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Marketing/components/RealTimeAudiences/assets/RealTimeAudience@2x.png
var RealTimeAudience_2x = __webpack_require__(65847);
var RealTimeAudience_2x_default = /*#__PURE__*/__webpack_require__.n(RealTimeAudience_2x);
// EXTERNAL MODULE: ./src/views/Marketing/components/RealTimeAudiences/assets/RealTimeAudience.webp
var RealTimeAudience = __webpack_require__(24353);
var RealTimeAudience_default = /*#__PURE__*/__webpack_require__.n(RealTimeAudience);
// EXTERNAL MODULE: ./src/views/Marketing/components/RealTimeAudiences/assets/RealTimeAudience@2x.webp
var assets_RealTimeAudience_2x = __webpack_require__(86051);
var assets_RealTimeAudience_2x_default = /*#__PURE__*/__webpack_require__.n(assets_RealTimeAudience_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Marketing/components/RealTimeAudiences/RealTimeAudiencesImage.tsx









var RealTimeAudiencesImage = function RealTimeAudiencesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledElevation, {
    elevation: 4,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((RealTimeAudience_default()), ", ").concat((assets_RealTimeAudience_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        src: (RealTimeAudience_2x_default()),
        alt: "Real-time audiences",
        width: "640",
        height: "534",
        loading: "lazy"
      })]
    })
  });
};

var StyledElevation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "efd7l910"
} : 0)("border:2px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[20];
}, ";border-radius:8px;" + ( true ? "" : 0));

/* harmony default export */ var RealTimeAudiences_RealTimeAudiencesImage = (RealTimeAudiencesImage);
;// CONCATENATED MODULE: ./src/views/Marketing/components/RealTimeAudiences/RealTimeAudiences.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var copy = {
  heading: "Real-time, intelligent audiences",
  description: "Target the right customer with the right message at the right time. Build audiences and create AI-powered real-time\ncampaigns, without relying on other teams."
};
var RealTimeAudiences_link = {
  text: "Explore Twilio Engage",
  url: "/product/twilio-engage/"
};
var features = [{
  heading: "Proactively personalize with Predictive Audiences",
  description: "CustomerAI Predictions includes pre-built Predictive Audiences to inspire new campaign ideas and help you quickly create AI-powered audiences in just a few clicks.",
  link: {
    text: "Learn more",
    href: "/solutions/ai/customerai-predictions/"
  },
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* EngagingIcon */.h, {})
}, {
  heading: "Instant mobile integrations",
  description: "Send an email or show an ad within minutes of a user performing an action.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* MobileIcon */.xO, {})
}, {
  heading: "Consistent content across platforms",
  description: "Send a consistent message across all channels \u2014 email, Facebook & Google ads, and in-product.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* SafeIcon */.zQ, {})
}];

var PowerYourApps = function PowerYourApps() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionWrapper, {
    variant: "2Col",
    copyVariant: "narrow",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(RealTimeAudiences_link.url, pageConfig),
          children: RealTimeAudiences_link.text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          gap: "small",
          children: features.map(function (feature, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
              alignment: "left",
              headerPosition: "left",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                  elevation: 1,
                  variant: "circle",
                  children: feature.icon
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: feature.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: feature.description
                }), feature.link && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                    size: "small",
                    variant: "primary",
                    href: (0,getAbsoluteUrl/* default */.Z)(feature.link.href, pageConfig),
                    children: feature.link.text
                  })
                })]
              })]
            }, index);
          })
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RealTimeAudiences_RealTimeAudiencesImage, {})
    })]
  });
};

var SectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eg0lbxq1"
} : 0)( true ? {
  name: "ajfln6",
  styles: "overflow-x:visible"
} : 0);

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eg0lbxq0"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var RealTimeAudiences = (PowerYourApps);
;// CONCATENATED MODULE: ./src/views/Marketing/components/RealTimeAudiences/index.ts


/***/ }),

/***/ 65847:
/***/ (function(module) {

module.exports = "/_next/static/images/RealTimeAudience@2x-a7f04a355c665425f88022bbcd38d5f1.png";

/***/ }),

/***/ 24353:
/***/ (function(module) {

module.exports = "/_next/static/images/RealTimeAudience-a5727a50158370a5b037407fe3725780.webp";

/***/ }),

/***/ 86051:
/***/ (function(module) {

module.exports = "/_next/static/images/RealTimeAudience@2x-081c1bbddbd3da68e12f85da6d165823.webp";

/***/ })

}]);